<script setup lang="ts">

defineProps({
  base64: {
    type: String,
    default: '',
  },
  imageWidth: {
    type: Number,
    default: 32,
  },
  isCentered: {
    type: Boolean,
    default: true,
  },
});

</script>

<template>
  <div class="flex items-center pt-0 min-h-[40px]"
  :class="isCentered ? 'justify-center' : 'justify-end'">
    <template v-if="base64">
      <Image
        :src="base64"
        alt="Image"
        :width="imageWidth"
        preview
        class="flex items-center justify-center"
      />
    </template>
    <template v-else>
        <div class="w-[32px] h-[32px]">
          <Skeleton shape="cube" size="32px"></Skeleton>
        </div>
    </template>
  </div>
</template>

